import React__default, { useState, useRef, useEffect } from 'react';
import Input from '../../input/Input.esm.js';
import '../../input/PhoneInput.esm.js';
import { Label } from '../../ui/label.esm.js';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group.esm.js';
import t from '../../../services/translatorService.esm.js';

const AddClient = ({
  form,
  onChangeForm,
  errors: serverErrors,
  containerRef
}) => {
  const [errors, setErrors] = useState(serverErrors);
  const headlineRef = useRef(null);
  useEffect(() => {
    setErrors(serverErrors);
  }, [serverErrors]);
  const handleChange = (value, field) => {
    onChangeForm(() => ({
      ...form,
      [field]: value
    }));
    setErrors(prev => ({
      ...prev,
      [field]: undefined
    }));
  };
  const scrollToHeadline = () => {
    // the first input onFocus: scroll form to the top (so, user can see that it has more fields)
    if (headlineRef && containerRef) {
      containerRef.current?.scrollTo({
        top: headlineRef.current?.offsetTop - 20,
        behavior: "smooth"
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-xl font-semibold",
    ref: headlineRef
  }, t('proposals.newClient')), /*#__PURE__*/React__default.createElement("form", {
    className: "flex flex-col gap-6 mb-20"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RadioGroup, {
    name: "genderType",
    className: 'flex flex-row gap-4',
    defaultValue: form.genderType,
    onValueChange: value => handleChange(value, 'genderType')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React__default.createElement(RadioGroupItem, {
    value: "Mr",
    id: "mr"
  }), /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: "mr"
  }, t('proposals.addClient.mr'))), /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React__default.createElement(RadioGroupItem, {
    value: "Miss",
    id: "miss"
  }), /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: "miss"
  }, t('proposals.addClient.miss')))), errors?.genderType && /*#__PURE__*/React__default.createElement("div", {
    className: "text-error-dark text-sm"
  }, errors.genderType)), /*#__PURE__*/React__default.createElement(Input, {
    startIcon: /*#__PURE__*/React__default.createElement("i", {
      className: "ri-user-3-line"
    }),
    placeholder: t('proposals.addClient.firstName'),
    onChange: e => handleChange(e.target.value, 'firstName'),
    value: form.firstName,
    error: errors?.firstName,
    onFocus: scrollToHeadline
  }), /*#__PURE__*/React__default.createElement(Input, {
    startIcon: /*#__PURE__*/React__default.createElement("i", {
      className: "ri-user-3-line"
    }),
    placeholder: t('proposals.addClient.lastName'),
    onChange: e => handleChange(e.target.value, 'lastName'),
    value: form.lastName,
    error: errors?.lastName
  })));
};

export { AddClient as default };
//# sourceMappingURL=AddClient.esm.js.map
